import { useEffect, useRef, useState } from 'react';

export default function ModalVerPDF({ url, titulo, onClose, onDescargar, isAdmin }) {
  const canvasRef = useRef();
  const [pdf, setPdf] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const renderTask = useRef(null);

  // Carga el PDF
  useEffect(() => {
    if (!url) return;
    setLoading(true);
    setError(null);
    setPagina(1);

    import('pdfjs-dist').then(async (pdfjsLib) => {
      pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
      try {
        const loadingTask = pdfjsLib.getDocument(url);
        const pdfDoc = await loadingTask.promise;
        setPdf(pdfDoc);
        setTotal(pdfDoc.numPages);
        setLoading(false);
      } catch (err) {
        setError('No se pudo cargar el documento');
        setLoading(false);
      }
    });

    return () => {
      renderTask.current?.cancel();
    };
  }, [url]);

  // Renderiza la página actual
  useEffect(() => {
    if (!pdf || !canvasRef.current) return;

    const renderPagina = async () => {
      renderTask.current?.cancel();
      const page = await pdf.getPage(pagina);
      const canvas = canvasRef.current;
      const context = canvas.getContext('2d');
      const viewport = page.getViewport({ scale: 1.5 });

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      renderTask.current = page.render({ canvasContext: context, viewport });
      try {
        await renderTask.current.promise;
      } catch (err) {
        if (err?.name !== 'RenderingCancelledException') console.error(err);
      }
    };

    renderPagina();
  }, [pdf, pagina]);

  if (!url) return null;

  return (
    <div className="overlay" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#1a1a1a',
        borderRadius: 8,
        width: '90vw',
        height: '92vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      }}>

        {/* Toolbar */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: '10px 16px', background: '#2d2d2d',
          borderBottom: '1px solid #444', flexShrink: 0
        }}>
          <span style={{ color: '#fff', fontSize: 13, fontWeight: 500, flex: 1 }}>
            {titulo ?? 'Documento'}
          </span>

          {/* Navegación páginas */}
          {total > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button className="btn-secondary" style={{ padding: '3px 10px', fontSize: 12 }}
                onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={pagina === 1}>
                ‹
              </button>
              <span style={{ color: '#ccc', fontSize: 12, minWidth: 70, textAlign: 'center' }}>
                {pagina} / {total}
              </span>
              <button className="btn-secondary" style={{ padding: '3px 10px', fontSize: 12 }}
                onClick={() => setPagina(p => Math.min(total, p + 1))} disabled={pagina === total}>
                ›
              </button>
            </div>
          )}

          {/* Descarga solo para admin */}
          {isAdmin && onDescargar && (
            <button className="btn-primary" style={{ fontSize: 12, padding: '5px 12px' }}
              onClick={onDescargar}>
              Descargar
            </button>
          )}

          <button className="btn-secondary" style={{ fontSize: 12, padding: '5px 12px' }}
            onClick={onClose}>
            Cerrar
          </button>
        </div>

        {/* Visor */}
        <div style={{
          flex: 1, overflowY: 'auto', display: 'flex',
          alignItems: 'flex-start', justifyContent: 'center',
          padding: '1rem', background: '#525659'
        }}>
          {loading && (
            <div style={{ color: '#ccc', fontSize: 14, marginTop: '4rem' }}>
              Cargando documento...
            </div>
          )}
          {error && (
            <div style={{ color: '#f44', fontSize: 14, marginTop: '4rem' }}>{error}</div>
          )}
          {!loading && !error && (
            <canvas ref={canvasRef} style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
              maxWidth: '100%',
              userSelect: 'none',        // ← evita selección de texto
              WebkitUserSelect: 'none',
            }} />
          )}
        </div>
      </div>
    </div>
  );
}